<ngx-app-bar
  class="w-100"
  [title]="'امضای قراردادها'"
  [rightButton]="{
    icon: 'arrow-right',
    style: 'neutral-link',
    mode: 'icon-only',
    size: 'medium',
  }"
  (onRightButtonClick)="onBackHandler()"
/>

@if (loading) {
  <app-spinner />
} @else {
  <div class="container">
    <p>برای سرمایه‌گذاری در این صندوق نیاز است قرارداد‌های زیر را به صورت الکترونیکی امضا کنید:</p>

    <div class="agreement">
      @for (agreement of agreements; track $index) {
        <div class="row">
          <div class="key">
            {{ agreement.description }}
          </div>
          <div
            class="link"
            (click)="displayAggrenet(agreement)"
          >
            مشاهده
            <ngx-icon
              name="arrow-left"
              type="linear"
            ></ngx-icon>
          </div>
        </div>
      }
    </div>

    <mat-checkbox
      class="check"
      [(ngModel)]="checked"
    >
      با پذیرفتن شرایط این پنج قرارداد، آن‌ها را امضا میکنم.
    </mat-checkbox>

    <div class="button-container">
      <ngx-button
        buttonId="CONFIRM_AND_PAY"
        [style]="'fill'"
        size="medium"
        [fullWidth]="true"
        [disabled]="!checked || isUploading"
        (clickHandler)="agreement()"
        [isLoading]="isUploading"
      >
        تایید و پرداخت
      </ngx-button>
    </div>
  </div>
}
